import { render, staticRenderFns } from "./BankAccountView.vue?vue&type=template&id=fd20f642&scoped=true"
import script from "./BankAccountView.vue?vue&type=script&lang=js"
export * from "./BankAccountView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd20f642",
  null
  
)

export default component.exports